export const FORM_ERROR = 'Error';
export const FORM_WARNING = 'Warning';
